import {SharedEnumModelKeyValue} from "./shared.models";

export class AnagraficaUtenteIstruzioneDto {
  public IdAnagraficaUtenteIstruzione : number = 0;
  public IdAnagraficaUtente : number = 0;
  public TitoloStudio : string = "";
  public AnnoConseguimento : number = 0;
  public AnnoConseguimentoStr : string = "";
  public InCorso : boolean = false;
  public VotoConseguimento : string = "";
  public IdLivelloIstruzione : number = 0;
  public LivelloIstruzione : string = "";
  public VotoMassimo : string = "";
  public IdLivelloIstruzione1 : number = 0;
  public IdLivelloIstruzione2 : number = 0;
  public IdLivelloIstruzione3 : number = 0;
  public DescrizioneLivelloIstruzione1 : string = "";
  public DescrizioneLivelloIstruzione2 : string = "";
  public DescrizioneLivelloIstruzione3 : string = "";
}

export class LivelloIstruzione {
  public TitoloStudio : AnagraficaUtenteLivelloIstruzioneDto = new AnagraficaUtenteLivelloIstruzioneDto();
  public Settore : AnagraficaUtenteLivelloIstruzioneDto = new AnagraficaUtenteLivelloIstruzioneDto();
  public Specializzazione : AnagraficaUtenteLivelloIstruzioneDto = new AnagraficaUtenteLivelloIstruzioneDto();
}
export class AnagraficaUtenteLivelloIstruzioneDto {
  public IdLivelloIstruzione : number = 0;
  public Descrizione : string = "";
  public IdParent : number = 0;
  public Livello : number = 0;
}

export class GetIstruzioneViewModel {
  public Filtro : string = "";
  public Livello : number = 0;
  public IdParent : number = 0;
}

export class AnagraficaUtenteLingueDto {
  public IdAnagraficaUtenteLingua : number = 0;
  public IdAnagraficaUtente : number = 0;
  public IdLingua : number = 0;
  public IdLinguaLivelloScritto : number = 0;
  public IdLinguaLivelloParlato : number = 0;
  public LinguaDesc : string = "";
  public LinguaLivelloScritto : string = "";
  public LinguaLivelloParlato : string = "";
}

export class AnagraficaUtenteAttestatoDto {
  public IdAnagraficaUtenteAttestato : number = 0;
  public IdAnagraficaUtente : number = 0;
  public IdAttestato : number = 0;
  public AttestatoDesc : string = "";
  public DataConseguimento : Date = new Date();
  public DataConseguimentoStr : string = "";
}

export class AnagraficaUtenteConoscenzeDto {
  public IdAnagraficaUtenteConoscenza : number = 0;
  public IdAnagraficaUtente : number = 0;
  public IdConoscenzaCategoria : number = 0;
  public IdConoscenza : number = 0;
  public IdConoscenzaLivello : number = 0;
  public Conoscenza : string = "";
  public ConoscenzaLivello : string = "";
}

export class Lingua {
  public IdLingua : number = 0;
  public LinguaDesc : string = "";
}

export class Attestato {
  public IdAttestato : number = 0;
  public AttestatoDesc : string = "";
  public Annoconseguimento : Date = new Date();
}

export class Conoscenze {
  public IdConoscenza : number = 0;
  public IdConoscenzaCategoria : number = 0;
  public ConoscenzaDesc : string = "";
}
